<template>
	<div class="client-info-wrapper pt-5 px-4 pb-5 mx-0 mb-md-12 mb-10">
		<div class="text-dark-blue font-extralarge bold pl-1 pr-0 pb-4">
      {{ clientCompanyName }}
		</div>
			<div class="d-flex flex-md-row flex-column">
				<div class="d-flex client-info-content-wrapper pb-md-0 pb-8">
					<div class="label-wrapper client-label-wrapper mr-4">
						<span class="label">
							Industry
						</span>
					</div>

					<div class="align-self-center flex-1">
						<div class="d-flex align-items-center">
							<div class="icon mr-3">
								<industry-tag-icon :industry-tag-name="industryTag.toString()"/>
							</div>
							<div class="font-small vertical-middle flex-1">
								{{ industryTag.toString() }}
							</div>
						</div>
					</div>
				</div>
				<div class="client-info-content-wrapper d-flex">
					<div class="label-wrapper region-label-wrapper mr-4 mb-1">
						<span class="label">
							Region
						</span>
					</div>
					<div class="align-self-center flex-1">
						<div 
							class="region-info d-flex align-items-center"
							v-for="targetArea in targetAreas"
							:key="targetArea"
						>
							<div 
								class="icon mr-3"
							>
								<target-area-icon :target-area-name="targetArea" />
							</div>
							<div class="flex-1 font-small">
								{{ targetArea }}
							</div>
						</div>
					</div>
				</div>
			</div>
	</div>
</template>

<script>
import industryTagIcon from './industryTagIcon.vue';
import TargetAreaIcon from './targetAreaIcon.vue';
export default {
  components: {
    industryTagIcon,
    TargetAreaIcon
  },
	props: {
		caseStudy: {
      type: Object,
      default() {
        return null;
      }
    },
    // HACK: 要リファクタ
    // admin側の入力の際齟齬が発生するため配列で受け渡ししているが、1つしか選択しないため要修正
		industryTag: {
      type: Array,
      default() {
        return [];
      }
    },
		targetAreas: {
      type: Array,
      default() {
        return [];
      }
    }
	},
	computed: {
		clientCompanyName() {
      return this.caseStudy.isClientPublic ? this.caseStudy.clientCompanyName : this.caseStudy.publicClientCompanyName;
    }
	}
}
</script>

<style lang="scss" scoped>
.font-middle {
  line-height: 28.8px;
}
.client-info-wrapper {
  background-color: #E6F1FC;
  .icon {
    width: 60px;
    height: 60px;
  }
  .client-info-content-wrapper {
    width: 50%;
    @media (max-width: 767px) {
      width: 100%;
    }
    .label-wrapper {
      position: relative;
      width: 39px;
      .label {
        position: absolute;
        font-size: 32px;
        line-height: 38.5px;
        top: 0;
        color: white;
        font-weight: 700;
        transform: rotate(-90deg);
        transform-origin: top right;
      }
      &.client-label-wrapper {
        height: 134px;
        > .label {
          width: 134px;
          left: -134px;
          white-space: nowrap;
        }
      }
      &.region-label-wrapper {
        height: 110px;
        > .label {
          width: 110px;
          left: -110px;
        }
      }
    }
    .region-info {
      padding-bottom: 10px;
      &:last-child {
        padding-bottom: 0px;
      }
    }
  }
}
</style>
